import React from "react";
import { WbSubjectKind } from "../../workbench/types/WbTypes";

type Props = {
    kind: WbSubjectKind;
};

const WorkbenchNewEntityTypeTag: React.FC<Props> = ({ kind }) => (
    <span
        className={`workbench-new-entity-type workbench-new-entity-type-${kind.toLowerCase()}`}
    >
        {kind}
    </span>
);

export default WorkbenchNewEntityTypeTag;
